/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewempty2Inputs */

const en_letterpreviewempty2 = /** @type {(inputs: Letterpreviewempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one timeline event so we can draft a letter from your case facts.`)
};

const pt_letterpreviewempty2 = /** @type {(inputs: Letterpreviewempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione pelo menos um evento à cronologia para podermos redigir uma carta com base nos seus factos.`)
};

/**
* | output |
* | --- |
* | "Add at least one timeline event so we can draft a letter from your case facts." |
*
* @param {Letterpreviewempty2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewempty2 = /** @type {((inputs?: Letterpreviewempty2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewempty2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewempty2(inputs)
	return pt_letterpreviewempty2(inputs)
});
export { letterpreviewempty2 as "letterPreviewEmpty" }